import MenuOne from './MenuOne'
import MenuTwo from './MenuTwo'

export default function MenuContainer() {
  return (
    <section className='flex-none'>
      <MenuOne />
      <MenuTwo />
    </section>
  )
}
